import {Map} from 'mapbox-gl-js';

export default () => Map;



// WEBPACK FOOTER //
// ./map/map/mapboxMapClassGetter.js